import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Fade from 'react-reveal/Fade'

import Link from '../../utils/link'
import { classIcons } from '../../utils/post-types'
import useTypes from '../../hooks/use-types'

const GenericCard = ({ title = '', uri = '', excerpt = '', featuredImage = null, types = 'generic-card', sites, ...props }) => {

  let type = null
  const colors = useTypes()
  let color = '#00D991'
  let Icon = null

  const show = !!sites?.nodes?.find(site => site.slug === process.env.GATSBY_WP_CATEGORY_SITE_SLUG)
  if (sites?.nodes?.length > 0 && !show) return null

  switch (props.__typename) {
    case 'WpMachine':
      type = 'Machines'
      Icon = classIcons[type]
      break;
    case 'WpPost':
    default:
      type = types?.nodes?.length ? types.nodes[0].name : 'Article'
      color = colors[type] || color
      Icon = classIcons[type] || classIcons['Company News']
      break;
  }

  return (
    <Link className='generic-card' to={uri}>
      <Fade distance='40px' bottom>
        <div className='generic-card__image'>
          {featuredImage?.node?.localFile && <GatsbyImage loading='lazy' image={getImage(featuredImage?.node.localFile)} alt={title} />}
        </div>
        <div className='generic-card__content'>
          <div className='generic-card__type'>
            { Icon && <Icon color={color} /> }
            <span>{type}</span>
          </div>
          <h4 style={{ textDecorationColor: color }} dangerouslySetInnerHTML={{ __html: title }} />
          <div className='generic-card__excerpt' dangerouslySetInnerHTML={{ __html: excerpt }} />
          <div className='generic-card__read-more'>
            <button type='button'>
              <span>Read more</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="13.673" height="10.26" viewBox="0 0 13.673 10.26">
                <path d="M16.554,22.11l-.917-.9,3.584-3.584H8v-1.28H19.22l-3.6-3.6.917-.9,5.141,5.141Z" transform="translate(-8 -11.85)" fill="#434343" />
              </svg>
            </button>
          </div>
        </div>
      </Fade>
    </Link>
  )
}

export default GenericCard